import React, { useEffect, useState } from "react";
import { Trans } from "@lingui/macro";
import { useInputChange } from "hooks/useInputChange";
import { InputText } from "components/UI/InputText/InputText";
import { Button } from "components/UI/Button/Button";
import { Loader } from "components/UI/Loader/Loader";

// Type
export type typePopupEdit = {
  variant?: string;
  setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

// Component
export const PopupAdd: React.FC<typePopupEdit> = ({
  variant,
  setOpenPopup,
}) => {
  // Form data
  const {
    value: fromUserValue,
    changeValueHandler: fromUserChangeValueHandler,
  } = useInputChange("");
  const { value: toUserValue, changeValueHandler: toUserChangeValueHandler } =
    useInputChange("");
  const { value: posSnValue, changeValueHandler: posSnChangeValueHandler } =
    useInputChange("");

  const [loader, setLoader] = useState(false);

  // Validation
  const [validationObj, setValidationObj] = useState({
    requiredFrom: false,
    requiredTo: false,
    requiredPosSn: false,
  });

  useEffect(() => {
    if (fromUserValue.trim() === "") {
      setValidationObj((v) => {
        return { ...v, ...{ requiredFrom: false } };
      });
    } else {
      setValidationObj((v) => {
        return { ...v, ...{ requiredFrom: true } };
      });
    }
  }, [fromUserValue]);

  useEffect(() => {
    if (toUserValue.trim() === "") {
      setValidationObj((v) => {
        return { ...v, ...{ requiredTo: false } };
      });
    } else {
      setValidationObj((v) => {
        return { ...v, ...{ requiredTo: true } };
      });
    }
  }, [toUserValue]);
  useEffect(() => {
    if (posSnValue.trim() === "") {
      setValidationObj((v) => {
        return { ...v, ...{ requiredPosSn: false } };
      });
    } else {
      setValidationObj((v) => {
        return { ...v, ...{ requiredPosSn: true } };
      });
    }
  }, [posSnValue]);

  const onAddHandler = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoader(true);

    setOpenPopup(false);
  };

  const isDisabled = !(
    validationObj.requiredFrom &&
    validationObj.requiredTo &&
    validationObj.requiredPosSn
  );

  return (
    <form className="grid md:grid-cols-2">
      <div className="md:col-span-2">
        <div className="mb-2 ">
          <InputText
            id="title"
            name="title"
            label={<Trans>Cash desk serial number</Trans>}
            value={posSnValue}
            onChange={posSnChangeValueHandler}
            required={true}
            errorMessage={
              validationObj.requiredPosSn ? undefined : (
                <Trans>Required field</Trans>
              )
            }
            autoFocus={true}
            maxLength={50}
          />
        </div>
        <div className="mb-2 ">
          <InputText
            id="fromUser"
            name="fromUser"
            label={<Trans>From user</Trans>}
            value={fromUserValue}
            onChange={fromUserChangeValueHandler}
            required={true}
            errorMessage={
              validationObj.requiredFrom ? undefined : (
                <Trans>Required field</Trans>
              )
            }
            autoFocus={true}
            maxLength={100}
          />
        </div>
        <div className="mb-2 ">
          <InputText
            id="toUser"
            name="toUser"
            label={<Trans>To user</Trans>}
            value={toUserValue}
            onChange={toUserChangeValueHandler}
            required={true}
            errorMessage={
              validationObj.requiredTo ? undefined : (
                <Trans>Required field</Trans>
              )
            }
            autoFocus={true}
            maxLength={100}
          />
        </div>
      </div>

      <div className="flex gap-4 mt-5 sm:mt-4 flex-row-reverse">
        <Button
          type="submit"
          disabled={isDisabled}
          variant={variant}
          label={<Trans>Add</Trans>}
          onClick={(e) => onAddHandler(e)}
        />
        <Button
          type="button"
          secondary={true}
          label={<Trans>Cancel</Trans>}
          onClick={() => setOpenPopup(false)}
        />
      </div>
      {loader ? <Loader /> : null}
    </form>
  );
};
